export const getCommasInNum = (value: string | number) => String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
export const getDelCommas = (value: string) => value.replace(/,/gi, "");
export const getOnlyNumber = (value: string) => Number(value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1"));

// 8자이상, 대/소문자, 숫자,특수문자를 1개이상 포함
export const isPasswordValid = (value: string) =>
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&ㄱ-ㅎ|ㅏ-ㅣ|가-힣]{8,}$/.test(value);
